import {useMutation} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {ReportResult} from "../../../../types/ReportResult";
import { SaveEstimateRequest } from '../../../common/ee-tool/types/SaveEstimateRequest';

export const usePrintInternalCostTemp = (quoteID: number, password: string, estimate: SaveEstimateRequest) => {

    const {mutateAsync, isLoading} = useMutation({
        mutationFn: async () => {
            return await apiClient.post('/estimate/print-internal-cost', {
                quoteID,
                password,
                estimate
            }) as ReportResult;
        }
    });

    return {
        mutateAsync, isLoading
    }
}
